import { combineReducers } from 'redux'
import applications from './applications'
import authentication from './authentication'
import boosts from './boosts'
import campaigns from './campaigns'
import campaignPartners from './campaignPartners'
import categories from './categories'
import donations from './donations'
import emailActivity from './emailActivity'
import faqs from './faqs'
import feedback from './feedback'
import instagramBioLinks from './instagramBioLinks'
import opportunities from './opportunities'
import organisations from './organisations'
import payments from './payments'
import people from './people'
import personalGoals from './personalGoals'
import platformEvents from './platformEvents'
import places from './places'
import search from './search'
import stats from './stats'
import stories from './stories'
import subscriptions from './subscriptions'
//
// growsmart sagas
//
import growsmart from './growsmart'

export default combineReducers({
  applications,
  authentication,
  boosts,
  campaigns,
  campaignPartners,
  categories,
  donations,
  emailActivity,
  faqs,
  feedback,
  instagramBioLinks,
  opportunities,
  organisations,
  payments,
  people,
  places,
  personalGoals,
  platformEvents,
  search,
  stats,
  stories,
  subscriptions,
  //
  // growsmart sagas
  //
  growsmart
})
